module.exports = __webpack_public_path__ + "static/media/icon1.48d3c2a3.svg";